import api from "./api.js";

export default class BasicApi {
  static async getBasicInfo() {
    return await api.get(`base-info`);
  }
  static async updateBasicInfo(data) {
    return await api.patch(`base-info`, data);
  }
}
